var _path, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomAutoLoad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 16.001v-.996h9v.996h-9zm8.537-6.848L8 13.255 3.148 8.386l.704-.7L7.5 11.342V4.001h1v7.341l2.103-2.189h1.434z",
    fill: "currentColor"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Custom_-_AutoLoad_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 9,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.075.077l8.776.001-.446 8.135h-5.87V4.026l-2.46.35v-4.3z",
    fill: "#ff0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Custom_-_AutoLoad_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.624a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
    stroke: "currentColor"
  }))));
}

export default SvgCustomAutoLoad;